<template>
  <section class="business-module">
    <h2 class="section-title">业务板块</h2>
    <!-- 六宫格 -->
    <div class="grid-container">
      <div
        class="grid-item"
        v-for="(item, index) in gridItems"
        :key="index"
        :class="{ clickable: item.route }"
        @click="goTo(item.route)"
      >
        <img :src="item.image" :alt="item.title" />
        <div class="overlay">
          <h3>{{ item.title }}</h3>
          <p v-if="item.desc">{{ item.desc }}</p>
        </div>
      </div>
    </div>
    <!-- 下方统计 -->
    <div class="statistics">
      <div class="stat" v-for="(stat, index) in stats" :key="index">
        <span class="number">{{ stat.number }}</span>
        <span class="label">{{ stat.label }}</span>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: "BusinessModule",
  data() {
    return {
      gridItems: [
        {
          title: "机构概况",
          desc: "省实验室由山东省和烟台市共建事业法人单位",
          route: "/about",
          image: new URL('@/assets/images/business/yyjzyj.jpg', import.meta.url).href
        },
        {
          title: "先进材料",
          route: "/application/materials",
          image: new URL('@/assets/images/business/rcyjhpy.jpg', import.meta.url).href
        },
        {
          title: "绿色制造",
          route: "/application/manufacturing",
          image: new URL('@/assets/images/business/jycy.jpg', import.meta.url).href
        },
        {
          title: "公共研发平台",
          route: "/research/platform",
          image: new URL('@/assets/images/business/xxcyyj.jpg', import.meta.url).href
        },
        {
          title: "研究中心",
          route: "/research/center",
          image: new URL('@/assets/images/business/small-cjrh.jpg', import.meta.url).href
        },
        {
          title: "联合研发中心",
          route: "/research/joint",
          image: new URL('@/assets/images/business/yyjzyjmb.jpg', import.meta.url).href
        }
      ],
      stats: [
        { number: 3, label: "公共研发平台" },
        { number: 5, label: "研究中心" },
        { number: 6, label: "联合研发中心" },
        { number: 9, label: "研究方向" }
      ]
    };
  },
  methods: {
    goTo(route) {
      if (route) {
        this.$router.push(route);
      }
    }
  }
};
</script>
<style scoped src="@/assets/styles/businessmodule.css"></style>
